import i18n from "Config/i18n";
import { FilterConfig } from "Components/ScrollableTable/ScrollableTable";
import { get } from "lodash";

/**
 * Provides robust way to set filters to Table component (https://ant.design/components/table/) or ScrollableTable.tsx
 * Returned value can be pasted in "filters" prop of Table "columns".
 * @param data - array of objects that represents table data
 * @param pathToKey - path to key object by which return unique values
 * @param pathToVal - path to value object if it differs from pathToKey
 */
export function getFiltersForTable<T>(
  data: Array<T>,
  pathToKey: string,
  pathToVal: string = pathToKey,
  pathToDescription?: string
): FilterConfig[] {
  // const uniqueValues = Array.from(new Set(data.map(i => i[key]))); Doesn't work in IE11 :(
  if (data?.length) {
    return Object.values(
      data.reduce(
        (map, current) => {
          let key: number | string | string[] = get(current, pathToKey, "") as number | string | string[];
          if (typeof key === "number") {
            key = key.toString();
          }
          if (key?.length && !map[key as string]) {
            const value = get(current, pathToVal, "");
            const description = get(current, pathToDescription, "");
            if (Array.isArray(key)) {
              key.forEach((text, index) => {
                map[text] = {
                  text,
                  value: value?.[index],
                  description: description?.[index],
                };
              });
            } else {
              map[key] = { text: key, value, description: description };
            }
          }
          return map;
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        {} as any
      )
    );
  }
  return [];
  // const mappedData = data.map(i => i[key]);
  // const uniqueValues = mappedData.filter((item, idx) => {
  //   return item && mappedData.indexOf(item) === idx;
  // });
  // return uniqueValues.map(i => ({ text: i, value: i }));
}

// tslint:disable-next-line: typedef
function sortFilterTypesForDocuments(a, b) {
  if ((a.value as string).startsWith("FOL")) {
    return -1;
  } else {
    return a.value > b.value ? 1 : -1;
  }
}

export function getFiltersForDocumentsTable<T, K extends keyof T>(data: Array<T>, key: K) {
  return getFiltersForTable(data, key as string)
    .map((item) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if ((item as any).value === "FOLDER") {
        return { text: i18n.t("project:::dir"), value: "FOLDER" };
      }
      return item;
    })
    .sort(sortFilterTypesForDocuments);
}
